import { createIcon } from "@chakra-ui/icons";

// Created from chevron-right.svg

export const ChevronRightIcon = createIcon({
  displayName: "Right Arrow",
  viewBox: "0 0 16 16",
  path: (
    <g>
      <path
        id="icon/navigation/arrow_drop_down_24px"
        d="M6 13L12 8L6 3L6 13Z"
        fill="currentColor"
      />
    </g>
  ),
});
